import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';

/**
 * Adds X-Attq-Client-Version header to all requests
 * Format: shortCommitHash-datetime (e.g., c2a4a13-2601141230)
 * This allows the backend to track which client version is making requests for debugging and analytics.
 */
@Injectable({
  providedIn: 'root'
})
export class ClientVersionInterceptor implements HttpInterceptor {
  private clientVersion: string;

  constructor() {
    this.clientVersion = this.buildClientVersion();
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!request.url.startsWith(environment.serverUrl)) {
      return next.handle(request);
    }

    const clonedRequest = request.clone({
      setHeaders: {
        'X-Attq-Client-Version': this.clientVersion
      }
    });

    return next.handle(clonedRequest);
  }

  private buildClientVersion(): string {
    const shortCommit = environment.commitHash ? environment.commitHash.substring(0, 9) : 'unknown';
    const buildDate = environment.buildDate || 'unknown';
    return `${shortCommit}-${buildDate}`;
  }
}
